import { makeStyles } from "@material-ui/core";
import { DPSpacerProps } from "./DPSpacer";

const useStyles = makeStyles(theme => ({
  spacer: {
    flexBasis: ({ spacing = 1 }: DPSpacerProps) => theme.spacing(spacing),
    flexGrow: ({ grow }: DPSpacerProps) => grow || 0,
    flexShrink: ({ shrink }: DPSpacerProps) => shrink || 0,
  },
}));

export default useStyles;
